module.exports = __webpack_public_path__ + "files/b07fc5b16bb5ecf336f31a8e993c9865.eot";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-italic.eot
// module id = 351
// module chunks = 60